export default __webpack_public_path__ + "static/media/1025.5b50175f.png";